module.exports = __webpack_public_path__ + "static/media/shortBreak.71908295.svg";